// Mattress Reviews & Comparisons modal
import React from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import AboutCashbackModal from "../modals/about-cashback-modal.jsx";
import CodePromoButton from "./code.jsx";
import DataLayerService from "datalayer-service";
import {CashbackCodeAction} from "datalayer-service/src/types/enums";

const dataLayerService = new DataLayerService(window);
export const ID = "cashback-btn";

class CashbackPromoButton extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            screenSize: 0,
            showAboutCashback: false,
        };

        this.handleResize = this.handleResize.bind(this);
        this.handleCashbackModal = this.handleCashbackModal.bind(this);
        this.handleOpenAboutCashbackModal =
            this.handleOpenAboutCashbackModal.bind(this);
        this.handleCloseAboutCashbackModal =
            this.handleCloseAboutCashbackModal.bind(this);
    }

    componentDidMount() {
        window.addEventListener("resize", this.handleResize);

        this.setState({
            screenSize: this.getScreenSize(),
        });
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
    }

    getScreenSize() {
        const isClient = typeof document === "object";

        return isClient ? document.body.clientWidth : 0;
    }

    handleResize() {
        this.setState({
            screenSize: this.getScreenSize(),
        });
    }

    handleCashbackModal() {
        const {
          storeSlug,
          storeName,
          retailerSlug,
          retailerName,
          promotionID,
          promoType,
          pageRegion,
          source
        } = this.props;

        dataLayerService.retailerCashbackCodeInterationEvent({
          action: CashbackCodeAction.CLICK,
          retailerName: retailerName || retailerSlug || storeName || storeSlug,
          retailerLocation: storeSlug || retailerSlug,
          pageRegion: pageRegion,
          source: source,
          type: promoType,
        });

        if (storeSlug) {
            window.location.href = `/cashback-code/${promotionID}/?store=${storeSlug}&type=${promoType}&prev=${
                window.location.pathname + window.location.search
            }`;
        } else {
            window.location.href = `/cashback-code/${promotionID}/?retailer=${retailerSlug}&type=${promoType}&prev=${
                window.location.pathname + window.location.search
            }`
        }
    }

    handleOpenAboutCashbackModal(e) {
        e.stopPropagation();

        this.setState({
            showAboutCashback: true,
        });

        dataLayerService.retailerCashbackCodeInterationEvent({
          action: CashbackCodeAction.CLICK,
          retailerName: this.props.retailerName || this.props.retailerSlug || this.props.storeName || this.props.storeSlug,
          retailerLocation: this.props.storeSlug || this.props.retailerSlug,
          pageRegion: this.props.pageRegion,
          source: this.props.source,
          type: this.props.promoType,
        });
    }

    handleCloseAboutCashbackModal() {
        this.setState({
            showAboutCashback: false,
        });
    }

    render() {
        const {screenSize, showAboutCashback} = this.state;
        const {storeName, codeEnding, showButton, longText} = this.props;

        return (
            <>
                <button
                    className={`compact-promo-box cashback-promo-btn ${
                        longText ? "has-long-text" : ""
                    }`}
                    rel="nofollow"
                    onClick={
                        screenSize <= 576
                            ? this.handleOpenAboutCashbackModal
                            : this.handleCashbackModal
                    }
                >
                    {longText ? (
                        <>
                            <i className="cashback-icon fa fa-info-circle"/>
                            <span
                                style={{
                                    fontWeight: "normal",
                                    textAlign: "left",
                                }}
                            >
                                Plus,{" "}
                                <b>get an extra Cash Back from GoodBed</b>{" "}
                                if you spend $599 or more.
                            </span>
                        </>
                    ) : (
                        "Extra Cash Back"
                    )}
                    {showButton && (
                        <CodePromoButton
                            codeEnding={codeEnding}
                            onClick={
                                screenSize <= 576
                                    ? this.handleOpenAboutCashbackModal
                                    : this.handleCashbackModal
                            }
                        />
                    )}
                </button>
                {showAboutCashback && (
                    <AboutCashbackModal
                        codeEnding={codeEnding}
                        storeName={storeName}
                        storeSlug={this.props.storeSlug}
                        retailerName={this.props.retailerSlug}
                        onCashbackClick={this.handleCashbackModal}
                        onHide={this.handleCloseAboutCashbackModal}
                    />
                )}
            </>
        );
    }
}

CashbackPromoButton.defaultProps = {
    longText: false,
};

CashbackPromoButton.propTypes = {
    storeSlug: PropTypes.string.isRequired,
    storeName: PropTypes.string.isRequired,
    promotionID: PropTypes.number.isRequired,
    retailerSlug: PropTypes.string,
    retailerName: PropTypes.string,
    codeEnding: PropTypes.string,
    showButton: PropTypes.bool,
    longText: PropTypes.bool,
    locationPage: PropTypes.string,
    pageRegion: PropTypes.string,
    source: PropTypes.string,
    promoType: PropTypes.string,
};

export default CashbackPromoButton;

export function initCashbackPromoButtons(selector= `[id=${ID}]`) {
    const promoInstances = Array.from(document.querySelectorAll(selector));

    for (let element of promoInstances) {
        const storeSlug = element.getAttribute("data-store-slug");
        const storeName = element.getAttribute("data-store-name");
        const retailerSlug = element.getAttribute("data-retailer-slug");
        const retailerName = element.getAttribute("data-retailer-name");
        const promotionID = element.getAttribute("data-promotion-id");
        const codeEnding = element.getAttribute("data-code-ending");
        const showButton = element.getAttribute("data-show-button") || false;
        const longText = element.getAttribute("data-long-text") || false;
        const locationPage = element.getAttribute("data-location-page") || "";
        const pageRegion = element.getAttribute("data-page-region") || "";
        const source = element.getAttribute("data-source") || "";
        const promoType = element.getAttribute("data-promo-type") || "";

        ReactDOM.render(
            <CashbackPromoButton
                storeSlug={storeSlug}
                storeName={storeName}
                retailerSlug={retailerSlug}
                retailerName={retailerName}
                promotionID={promotionID ? parseInt(promotionID) : null}
                codeEnding={codeEnding}
                showButton={showButton ? showButton === "true" : false}
                longText={longText ? longText === "true" : false}
                locationPage={locationPage}
                source={source}
                promoType={promoType}
                pageRegion={pageRegion}
            />,
            element
        );
    }
}
